import { ReactNode } from "react";
import styles from "./Card.module.css";

interface CardProps {
  children: ReactNode;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
}

export default function Card({
  children,
  disabled = false,
  className,
  onClick,
}: CardProps) {
  const combinedClassName =
    `${styles.card} ${disabled ? styles.disabled : ""} ${className || ""}`.trim();

  return (
    <div
      className={combinedClassName}
      onClick={disabled ? undefined : onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick && !disabled ? 0 : undefined}
      onKeyDown={
        onClick && !disabled
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
    >
      {children}
    </div>
  );
}
